/*
 * @Author: your name
 * @Date: 2021-04-28 13:22:03
 * @LastEditTime: 2021-05-20 14:18:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/config/module/modal/system.config.js
 */
// 系统配置/运营中心
export default {
  MODIFY_ENV: {
    component: () => import(
      /* webpackChunkName: 'SystemConfigModal' */
      '@/views/modal/systemConfig/MODIFY_ENV.vue'
    ),
  },

  // 运营中心
  MANUALMATCHINGRODUCTYNC: {
    component: () => import(
      /* webpackChunkName: 'SystemConfigModal' */
      '@/views/modal/systemConfig/MANUALMATCHINGRODUCTYNC.vue'
    ),
  },
  BATCHUPDATESRODUCTYNC: {
    component: () => import(
      /* webpackChunkName: 'SystemConfigModal' */
      '@/views/modal/systemConfig/BATCHUPDATESRODUCTYNC.vue'
    ),
  },
  UPDATE_END_TIME: {
    component: () => import(
      /* webpackChunkName: 'SystemConfigModal' */
      '@/views/modal/commodityCenter/UPDATE_END_TIME.vue'
    ),
  },
  ADD_PRE_SALE_QUANTITY: {
    component: () => import(
      /* webpackChunkName: 'SystemConfigModal' */
      '@/views/modal/commodityCenter/ADD_PRE_SALE_QUANTITY.vue'
    ),
  },
};
